export var SCHEMA_TYPES = {
    RESTAURANTS_MENU_PAGE_IMAGES: 'restaurants-menu-page-images-preset',
};
